class ApiService {
    constructor() {
        this.baseURL = import.meta.env.VITE_API_BASE_URL
        console.log(this.baseURL)
        this.token = null
    }

    setToken(token) {
        this.token = token
    }

    async request(endpoint, options = {}) {
        const { timeoutMs = 20000, ...fetchOptions } = options

        const headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ...(this.token && { Authorization: `Bearer ${this.token}` }),
        }

        const controller = new AbortController()
        const timeoutId = setTimeout(() => controller.abort(), timeoutMs)

        let response
        try {
            response = await fetch(`${this.baseURL}${endpoint}`, {
                headers,
                ...fetchOptions,
                signal: controller.signal,
            })
        } catch (error) {
            if (error.name === 'AbortError') {
                const timeoutError = new Error(`API request timed out after ${timeoutMs}ms: ${endpoint}`)
                timeoutError.status = 0
                throw timeoutError
            }
            throw error
        } finally {
            clearTimeout(timeoutId)
        }

        if (!response.ok) {
            const error = new Error(`API request failed: ${response.status} ${response.statusText}`)
            error.status = response.status
            try {
                error.data = await response.json()
            } catch {
                error.data = null
            }
            throw error
        }

        return response.json()
    }

    async get(endpoint) {
        return this.request(endpoint, { method: 'GET' })
    }

    async post(endpoint, data) {
        return this.request(endpoint, {
            method: 'POST',
            body: JSON.stringify(data),
        })
    }

    async put(endpoint, data) {
        return this.request(endpoint, {
            method: 'PUT',
            body: JSON.stringify(data),
        })
    }

    async patch(endpoint, data) {
        return this.request(endpoint, {
            method: 'PATCH',
            body: JSON.stringify(data),
        })
    }

    async delete(endpoint) {
        return this.request(endpoint, { method: 'DELETE' })
    }
}

export const apiService = new ApiService()
